<script>
export default {
  name: 'address-detail',
  props: {
    addressEnableZipCode: {
      type: Boolean,
      default: false
    },
    addressEnableContactPerson: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  model: {
    prop: 'value'
  },
  computed: {
    address () {
      if (!this.value || !this.value.id || !Object.keys(this.value).length) return '-'
      const v = this.value
      const areaStr =  `${v.provinceName} ${v.cityName} ${v.countyName} ${v.townName || ''}`
      let addressStr = v.addressInfo
      if (this.addressEnableZipCode) {
        addressStr += v.postalCode
      }
      if (this.addressEnableContactPerson) {
        addressStr += ` ${v.name ? v.name + ' 收 ' : ''}${v.mobile || ''}`
      }
      return areaStr + addressStr
    }
  },
  render (h) {
    return <read-text value={this.address}></read-text>
  }
}
</script>

// <style lang="scss" scoped>
// .tip-content {
//   max-width: 400px;
// }
// .paas-address-detail {
//   display: inline-block;
//   max-height: 32px;
//   line-height: 16px;
//   vertical-align: top;
// }
// .line-clamp {
//   overflow: hidden;
//   text-overflow: ellipsis;
//   display: -webkit-box;
//   -webkit-line-clamp: 2;
//   -webkit-box-orient: vertical;
//   max-height: 32px;
// }
// </style>